import { c as _c } from "react/compiler-runtime";
import { Flexbox, RadioButtonGroup, Spacing, TextLink } from '@newfront-insurance/core-ui';
import { SchemaInputControl, type Schema } from '@newfront-insurance/dsl-schema-ui';
import type { JSX } from 'react';

// eslint-disable-next-line import/no-cycle

interface Props {
  value?: {
    state?: string;
    address?: object;
  };
  name: string;
  fieldPath: string;
  schema: Schema;
  onChange: (value: unknown) => void;
  accountUuid?: string;
}
export function AddressOrState(t0) {
  const $ = _c(34);
  const {
    value,
    onChange,
    schema,
    name,
    fieldPath,
    accountUuid
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: 400
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== value) {
    t2 = getRadioValue(value);
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      value: "address",
      label: "Address"
    }, {
      value: "state",
      label: "State only"
    }];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onChange) {
    t4 = radioValue => {
      if (radioValue === "address") {
        onChange({
          address: null
        });
      }
      if (radioValue === "state") {
        onChange({
          state: ""
        });
      }
    };
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <RadioButtonGroup direction="horizontal" name="address-or-state" value={t2} options={t3} onChange={t4} />;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onChange || $[10] !== value) {
    t6 = value && <TextLink underlineOnHover={true} onClick={() => {
      onChange(undefined);
    }}>Clear</TextLink>;
    $[9] = onChange;
    $[10] = value;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Flexbox>{t5}{t6}</Flexbox>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== value) {
    t8 = value && <Spacing height={12} />;
    $[15] = value;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== accountUuid || $[18] !== fieldPath || $[19] !== name || $[20] !== schema || $[21] !== value?.state) {
    t9 = value?.state !== undefined && schema.properties?.state && <SchemaInputControl schema={schema.properties.state} fieldPath={`${fieldPath}.state`} name={name} type={schema.properties.state.inputType} metadata={schema.properties.state.inputMetadata} accountUuid={accountUuid} />;
    $[17] = accountUuid;
    $[18] = fieldPath;
    $[19] = name;
    $[20] = schema;
    $[21] = value?.state;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== accountUuid || $[24] !== fieldPath || $[25] !== name || $[26] !== schema || $[27] !== value?.address) {
    t10 = value?.address !== undefined && schema.properties?.address && <SchemaInputControl schema={schema.properties.address} fieldPath={`${fieldPath}.address`} name={name} type={schema.properties.address.inputType} metadata={schema.properties.address.inputMetadata} accountUuid={accountUuid} />;
    $[23] = accountUuid;
    $[24] = fieldPath;
    $[25] = name;
    $[26] = schema;
    $[27] = value?.address;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t11 = <div style={t1}>{t7}{t8}{t9}{t10}</div>;
    $[29] = t10;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}
function getRadioValue(value: Props['value']): string | undefined {
  if (value?.address !== undefined) {
    return 'address';
  }
  if (value?.state !== undefined) {
    return 'state';
  }
  return undefined;
}